import React from 'react';
import { Row, Col } from 'antd';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import messages from './messages';

function SurveyFooter() {
	return (
		<Row type='flex' justify='space-between' align='middle' className='SurveyFooter'>
			<Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 18 }}>
				<FormattedHTMLMessage {...messages.copyright} />
			</Col>
			<Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }}>
				<div className="mail">
					<FormattedMessage {...messages.email} />
				</div>
			</Col>
		</Row>
	);
}

export default SurveyFooter;






// WEBPACK FOOTER //
// ./src/components/SurveyFooter/SurveyFooter.js